module.exports = __webpack_public_path__ + "img/about-office-img-4.bfee22da.jpg";